import React, { Component } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { setObj } from "../../actions/noteActions";
import Breadcrumb from "../../components/Breadcrumb";
import Loading from "../../components/Loading";
import StudentStatusTable from "../../components/OfflineRegister/StudentStatusTable";
import ProtectedRoute from "../../components/ProtectedRoute";
import SelectFilter from "../../components/SelectFilter";
import URL from "../../config/api";
import axios from "../../config/axios";

class PedagogicalFollowUps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      groupList: [],
      regionList: [],
      schoolList: [],
      yearList: [],
      turmasList: [],
      disciplinasList: [],
      seriesList: [],
      groupID: props.general.active_roles.group_id ?? null,
      regionID: props.general.active_roles.region_id ?? null,
      schoolID: props.general.active_roles.school_id ?? null,
      serieID: null,
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      monthList: [],
      turmaID: null,
      disciplinaID: null,
      showTable: false,
      allocationsData: [],
      loadingAllocations: false,
      studentList: [],
      loadingStudents: false,
      loadingGroups: false,
      loadingRegions: false,
      loadingSchools: false,
      loadingTurmas: false,
      loadingSeries: false,
      loadingDisciplinas: false
    };
  }

  getSeries = async () => {
    try {
      const { user } = this.props;
      const { groupID, regionID, schoolID } = this.state;

      const params = {};
      if (groupID) params.group_id = groupID;
      if (regionID) params.region_id = regionID;
      if (schoolID) params.school_id = schoolID;

      const response = await axios.get(
        `${URL.api}pedagogical/follow-ups/serie/list`,
        {
          params,
          headers: { Authorization: `Bearer ${user.token}` }
        }
      );

      const series = response.data?.data.map(s => ({
        label: s.name,
        value: s.id
      }));
      this.setState({ seriesList: series });
    } catch (error) {
      toastr.error("Erro", "Falha ao carregar a lista de séries.");
    }
  };

  getSeriesWithFilters = async () => {
    try {
      const { user } = this.props;
      const { groupID, regionID, schoolID } = this.state;

      const params = {};
      if (groupID) params.group_id = groupID;
      if (regionID) params.region_id = regionID;
      if (schoolID) params.school_id = schoolID;

      if (!groupID && !regionID && !schoolID) {
        this.setState({ seriesList: [] });
        return;
      }

      this.setState({ loadingSeries: true });

      const response = await axios.get(
        `${URL.api}pedagogical/follow-ups/serie/list`,
        {
          params,
          headers: { Authorization: `Bearer ${user.token}` }
        }
      );

      const series =
        response.data?.data?.map(s => ({
          label: s.name,
          value: s.id
        })) || [];

      this.setState({ seriesList: series, loadingSeries: false });
    } catch (error) {
      console.error("Erro ao carregar séries:", error);
      toastr.error("Erro", "Falha ao carregar a lista de séries.");
      this.setState({ seriesList: [], loadingSeries: false });
    }
  };

  componentDidMount() {
    this.props.setObj(
      this.props.currentRoute,
      this.props.currentRoute,
      this.props.currentRoute
    );
    const arrYear = [];
    const year = new Date().getFullYear();
    for (let i = 2; i >= 0; i--) {
      arrYear.push({ label: year - i, value: year - i });
    }

    const arrMonth = [
      { label: "Janeiro", value: 1 },
      { label: "Fevereiro", value: 2 },
      { label: "Março", value: 3 },
      { label: "Abril", value: 4 },
      { label: "Maio", value: 5 },
      { label: "Junho", value: 6 },
      { label: "Julho", value: 7 },
      { label: "Agosto", value: 8 },
      { label: "Setembro", value: 9 },
      { label: "Outubro", value: 10 },
      { label: "Novembro", value: 11 },
      { label: "Dezembro", value: 12 }
    ];

    this.setState({ yearList: arrYear, monthList: arrMonth });
    this.loadInitialData().then(() => {
      this.loadFiltersFromStorage();
    });
    this.setupHistoryListener();
    window.addEventListener("storage", this.handleExecutionSaved);
  }

  componentWillUnmount() {
    window.removeEventListener("storage", this.handleExecutionSaved);
    try {
      window.removeEventListener("popstate", this.handleRouteChange);
      window.removeEventListener("pushState", this.handleRouteChange);
      window.removeEventListener("replaceState", this.handleRouteChange);
      if (this._origPushState) window.history.pushState = this._origPushState;
      if (this._origReplaceState)
        window.history.replaceState = this._origReplaceState;
    } catch (e) {
      // ignore
    }
  }

  loadInitialData = async () => {
    const { user } = this.props;

    try {
      this.setState({ loadingGroups: true });
      const groupResponse = await axios.get(`${URL.api}access/group/list`, {
        headers: { Authorization: `Bearer ${user.token}` }
      });
      const groups = groupResponse.data?.data.map(g => ({
        label: g.name,
        value: g.id
      }));
      this.setState({ groupList: groups, loadingGroups: false });

      // Com filtro salvo, loadFiltersFromStorage carrega as listas logo em
      // seguida; carregar aqui também era fazer cada busca duas vezes.
      if (!this.hasSavedFilters()) await this.loadRoleLists();
    } catch {
      toastr.error(
        "Falha",
        "Não foi possível carregar os dados para os filtros."
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  // Listas que dependem só do papel ativo. Os IDs já estão no state desde o
  // constructor, então as buscas vão todas juntas, não uma depois da outra.
  loadRoleLists = async () => {
    const {
      group_id: groupId,
      region_id: regionId,
      school_id: schoolId
    } = this.props.general.active_roles;
    const { currentYear } = this.state;

    if (!groupId) {
      this.setState({ seriesList: [] });
      return;
    }

    const temEscola = regionId && schoolId;
    await Promise.all([
      this.getRegions(groupId),
      regionId && this.getSchools(regionId, groupId),
      temEscola && this.getTurmas(schoolId, currentYear),
      temEscola && this.loadDisciplines(groupId, regionId, schoolId),
      temEscola && this.getSeriesWithFilters()
    ]);
  };

  loadDisciplines = async (groupId, regionId, schoolId) => {
    try {
      const { user } = this.props;
      const params = {};
      if (groupId) params.group_id = groupId;
      if (regionId) params.region_id = regionId;
      if (schoolId) params.school_id = schoolId;

      this.setState({ loadingDisciplinas: true });

      const response = await axios.get(
        `${URL.api}pedagogical/follow-ups/discipline/list`,
        {
          params,
          headers: { authorization: `Bearer ${user.token}` }
        }
      );
      const disciplines = response.data.data.map(d => ({
        value: d.id,
        label: d.name
      }));
      this.setState({
        disciplinasList: disciplines,
        loadingDisciplinas: false
      });
    } catch (error) {
      console.error("Erro ao carregar disciplinas:", error);
      this.setState({ loadingDisciplinas: false });
    }
  };

  storageKey = "pedagogical_followups_filters";

  // A execução abre em outra aba; quando ela salva, grava esta chave e o
  // evento "storage" chega aqui: recarrega só o status dos alunos, sem tocar
  // nos filtros.
  handleExecutionSaved = event => {
    if (event.key !== "pedagogical_followups_execution_saved") return;
    const allocation = this.state.allocationsData[0];
    if (!allocation) return;
    toastr.success("Sucesso", "Acompanhamento salvo.");
    this.getStudentList(allocation.room_id, allocation.id);
  };

  saveFiltersToStorage = () => {
    try {
      const {
        groupID,
        regionID,
        schoolID,
        serieID,
        currentYear,
        currentMonth,
        turmaID,
        disciplinaID
      } = this.state;
      const payload = {
        groupID,
        regionID,
        schoolID,
        serieID,
        currentYear,
        currentMonth,
        turmaID,
        disciplinaID
      };
      localStorage.setItem(this.storageKey, JSON.stringify(payload));
    } catch (e) {
      // ignore storage errors
    }
  };

  hasSavedFilters = () => {
    try {
      return !!localStorage.getItem(this.storageKey);
    } catch (e) {
      return false;
    }
  };

  clearFiltersFromStorage = () => {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (e) {
      // ignore
    }
  };

  loadFiltersFromStorage = async () => {
    let saved;
    try {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) return;
      saved = JSON.parse(raw);
    } catch (e) {
      // Filtro salvo corrompido: descarta e carrega as listas do papel, que o
      // loadInitialData deixou para cá por achar que havia filtro salvo.
      this.clearFiltersFromStorage();
      await this.loadRoleLists();
      return;
    }

    // Filtro salvo por outro papel (ou outro usuário no mesmo navegador) não
    // vale: o nível que o papel ativo trava precisa bater com o salvo.
    const activeRoles = this.props.general.active_roles;
    const conflita = [
      ["group_id", "groupID"],
      ["region_id", "regionID"],
      ["school_id", "schoolID"]
    ].some(
      ([role, key]) =>
        activeRoles[role] &&
        saved[key] &&
        String(activeRoles[role]) !== String(saved[key])
    );
    if (conflita) {
      this.clearFiltersFromStorage();
      await this.loadRoleLists();
      return;
    }

    const groupID = activeRoles.group_id ?? saved.groupID ?? null;
    const regionID = activeRoles.region_id ?? saved.regionID ?? null;
    const schoolID = activeRoles.school_id ?? saved.schoolID ?? null;
    const serieID = saved.serieID ?? null;
    const currentYear = saved.currentYear ?? this.state.currentYear;
    const currentMonth = saved.currentMonth ?? this.state.currentMonth;

    // Os IDs entram no state ANTES das listas: getTurmas e getSeriesWithFilters
    // leem grupo/região/escola do state, e sem eles voltavam vazios — os
    // selects apareciam limpos ao voltar da execução.
    await new Promise(resolve => {
      this.setState(
        { groupID, regionID, schoolID, serieID, currentYear, currentMonth },
        resolve
      );
    });

    // Todas dependem só dos IDs acima, então vão juntas. A exceção são as
    // turmas, que esperam as séries: getTurmas cai no nome da série
    // (seriesList) quando nenhuma turma bate pelo id.
    const temFiltro = groupID || regionID || schoolID;
    const seriesETurmas = async () => {
      if (temFiltro) await this.getSeriesWithFilters();
      if (schoolID) await this.getTurmas(schoolID, currentYear, serieID);
    };
    await Promise.all([
      groupID && this.getRegions(groupID),
      groupID && regionID && this.getSchools(regionID, groupID),
      temFiltro && this.loadDisciplines(groupID, regionID, schoolID),
      seriesETurmas()
    ]);

    // getTurmas zera a turma (ou escolhe a única da lista); a salva só volta
    // se ainda estiver entre as opções.
    const turmaSalva = this.state.turmasList.some(
      t => String(t.value) === String(saved.turmaID)
    );
    this.setState(
      prevState => ({
        turmaID: turmaSalva ? saved.turmaID : prevState.turmaID,
        disciplinaID: saved.disciplinaID ?? null
      }),
      () => {
        if (this.state.turmaID) this.loadAllocations();
      }
    );
  };

  setupHistoryListener = () => {
    const wrap = type => {
      const orig = window.history[type];
      if (type === "pushState") this._origPushState = orig;
      if (type === "replaceState") this._origReplaceState = orig;
      return function wrapped(...args) {
        const rv = orig.apply(this, args);
        const ev = new Event(type);
        window.dispatchEvent(ev);
        return rv;
      };
    };
    try {
      window.history.pushState = wrap("pushState");
      window.history.replaceState = wrap("replaceState");
    } catch (e) {
      // ignore
    }

    window.addEventListener("popstate", this.handleRouteChange);
    window.addEventListener("pushState", this.handleRouteChange);
    window.addEventListener("replaceState", this.handleRouteChange);
  };

  handleRouteChange = () => {
    try {
      const path = window.location.pathname || "";
      const allowedRoot = "/pedagogical-follow-ups";
      const execRegex = /^\/pedagogical-follow-ups\/execution\/[^/]+\/[^/]+$/;
      const consolidatedRegex =
        /^\/pedagogical-follow-ups\/consolidated\/[^/]+$/;

      if (
        path === allowedRoot ||
        execRegex.test(path) ||
        consolidatedRegex.test(path)
      ) {
        return;
      }

      this.clearFiltersFromStorage();
    } catch (e) {
      // ignore
    }
  };

  getRegions = async groupId => {
    if (!groupId) {
      this.setState({
        regionList: [],
        schoolList: [],
        turmasList: [],
        regionID: null,
        schoolID: null,
        turmaID: null,
        serieID: null,
        disciplinaID: null
      });
      return;
    }
    this.setState({ loadingRegions: true });
    try {
      const response = await axios.get(
        `${URL.api}access/region/listRegionFilter/${groupId}`,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      );
      const regions = response.data?.data.map(r => ({
        label: r.name,
        value: r.id
      }));
      this.setState({ regionList: regions, loadingRegions: false });
    } catch {
      toastr.error("Erro", "Falha ao buscar regiões.");
      this.setState({ loadingRegions: false });
    }
  };

  getSchools = async (regionId, groupId) => {
    if (!regionId) {
      this.setState({
        schoolList: [],
        turmasList: [],
        schoolID: null,
        turmaID: null,
        serieID: null,
        disciplinaID: null
      });
      return;
    }
    this.setState({ loadingSchools: true });
    try {
      const response = await axios.get(
        `${URL.api}access/school/listSchoolFilter/${groupId}/${regionId}`,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      );
      const schools = response.data?.data.map(s => ({
        label: s.name,
        value: s.id
      }));
      this.setState({ schoolList: schools, loadingSchools: false });
    } catch {
      toastr.error("Erro", "Falha ao buscar escolas.");
      this.setState({ loadingSchools: false });
    }
  };

  getTurmas = async (schoolId, year, serieId = null) => {
    if (!schoolId || !this.state.regionID || !this.state.groupID) {
      this.setState({ turmasList: [], turmaID: null });
      return;
    }

    this.setState({ loadingTurmas: true });

    try {
      const { user } = this.props;

      const params = {
        group_id: this.state.groupID,
        region_id: this.state.regionID,
        school_id: schoolId,
        year
      };

      // Rota própria da tela: community/room/list montava alunos e professores
      // de cada turma (milhares de consultas) e aqui só se usa série/disciplinas.
      const response = await axios.get(
        `${URL.api}pedagogical/follow-ups/room/list`,
        {
          params,
          headers: { Authorization: `Bearer ${user.token}` }
        }
      );

      let turmas = response.data?.data || [];

      if (turmas.length === 0) {
        console.warn("Nenhuma turma encontrada com os filtros:", params);
      }

      const turmasProcessadas = turmas.map(turma => {
        let serieId = null;
        let serieName = null;
        let disciplinasDisponiveis = [];

        if (turma.room_disciplines && turma.room_disciplines.length > 0) {
          serieId = turma.room_disciplines[0].serie_id;
          serieName = turma.room_disciplines[0].serie_name;
          disciplinasDisponiveis = turma.room_disciplines.map(d => ({
            id: d.discipline_id,
            name: d.discipline_name,
            serieId: d.serie_id
          }));
        }

        return {
          ...turma,
          serieId,
          serieName,
          disciplinasDisponiveis
        };
      });

      if (serieId) {
        const turmasFiltradas = turmasProcessadas.filter(turma => {
          const match = turma.serieId == serieId;
          return match;
        });

        if (turmasFiltradas.length === 0 && turmasProcessadas.length > 0) {
          const serieSelecionada = this.state.seriesList.find(
            s => s.value == serieId
          );
          if (serieSelecionada) {
            const matchPorNome = turmasProcessadas.filter(turma => {
              if (!turma.serieName) return false;
              const nomeTurma = turma.serieName.toLowerCase().trim();
              const nomeSerie = serieSelecionada.label.toLowerCase().trim();
              return (
                nomeTurma.includes(nomeSerie) || nomeSerie.includes(nomeTurma)
              );
            });
            if (matchPorNome.length > 0) {
              turmas = matchPorNome;
            } else {
              turmas = [];
            }
          } else {
            turmas = [];
          }
        } else {
          turmas = turmasFiltradas;
        }
      } else {
        turmas = turmasProcessadas;
      }

      const turmasOptions = turmas.map(c => ({
        label: c.name,
        value: c.id,
        serieId: c.serieId,
        serieName: c.serieName,
        disciplinas: c.disciplinasDisponiveis
      }));

      let turmaID = null;
      if (turmasOptions.length === 1) {
        turmaID = turmasOptions[0].value;
      }

      this.setState({
        turmasList: turmasOptions,
        turmaID,
        loadingTurmas: false
      });
    } catch (error) {
      toastr.error("Erro", "Falha ao buscar turmas.");
      this.setState({ turmasList: [], loadingTurmas: false });
    }
  };

  handleFilterClick = () => {
    if (this.state.turmaID) {
      this.saveFiltersToStorage();
      this.loadAllocations();
    } else {
      toastr.warning(
        "Atenção",
        "Por favor, selecione uma turma para continuar."
      );
    }
  };

  loadAllocations = async () => {
    const { user } = this.props;
    const {
      currentYear,
      currentMonth,
      disciplinaID,
      groupID,
      regionID,
      schoolID,
      turmaID,
      serieID
    } = this.state;

    const endPeriod = `${currentYear}-12-31`;

    const params = {
      year: currentYear,
      month: currentMonth,
      discipline_id: disciplinaID,
      end_period: endPeriod,
      group_id: groupID,
      region_id: regionID,
      school_id: schoolID,
      room_id: turmaID
    };

    if (serieID) {
      params.serie_id = serieID;
    }

    this.setState({ loadingAllocations: true });

    try {
      const response = await axios.get(
        `${URL.api}pedagogical/follow-ups/allocations/list`,
        {
          params,
          headers: { Authorization: `Bearer ${user.token}` }
        }
      );

      const allocationsData = response.data || [];
      this.setState({
        allocationsData,
        showTable: true
      });

      if (allocationsData.length > 0) {
        const roomId = allocationsData[0].room_id;
        const allocationId = allocationsData[0].id;
        await this.getStudentList(roomId, allocationId);
      } else {
        this.setState({ studentList: [] });
      }

      toastr.success("Sucesso", "Dados carregados com sucesso!");
    } catch (error) {
      toastr.error("Erro", "Falha ao carregar os dados de alocação.");
      this.setState({ allocationsData: [] });
    } finally {
      this.setState({ loadingAllocations: false });
    }
  };

  getStudentList = async (roomId, allocationId) => {
    const { user } = this.props;

    this.setState({ loadingStudents: true });

    try {
      if (!roomId || !allocationId) {
        toastr.error("Erro", "Dados de alocação incompletos.");
        this.setState({ studentList: [] });
        return;
      }

      const response = await axios.get(
        `${URL.api}pedagogical/follow-ups/students/execution-status`,
        {
          params: {
            room_id: roomId,
            allocation_id: allocationId
          },
          headers: { Authorization: `Bearer ${user.token}` }
        }
      );

      const studentList = response.data?.data || [];
      this.setState({ studentList });
    } catch (error) {
      toastr.error("Erro", "Falha ao carregar a lista de estudantes.");
      this.setState({ studentList: [] });
    } finally {
      this.setState({ loadingStudents: false });
    }
  };

  handleConsolidadoClick = () => {
    const { allocationsData } = this.state;

    if (allocationsData.length > 0) {
      const allocationId = allocationsData[0].id;
      this.props.history.push(
        `/pedagogical-follow-ups/consolidated/${allocationId}`
      );
    } else {
      toastr.warning(
        "Atenção",
        "Selecione os filtros antes de visualizar o consolidado."
      );
    }
  };

  getStudentStatus = student => {
    const statusConfig = {
      Pendente: { text: "Pendente", class: "badge-secondary" },
      "Não enviado": { text: "Não enviado", class: "badge-danger" },
      Enviado: { text: "Enviado", class: "badge-success" }
    };

    const status = student.status || "Pendente";
    return statusConfig[status] || statusConfig.Pendente;
  };

  render() {
    const { general } = this.props;
    const {
      loading,
      groupList,
      groupID,
      regionList,
      regionID,
      schoolList,
      schoolID,
      yearList,
      currentYear,
      monthList,
      currentMonth,
      turmasList,
      turmaID,
      disciplinasList,
      disciplinaID,
      showTable,
      allocationsData,
      loadingAllocations,
      seriesList,
      serieID,
      studentList,
      loadingStudents,
      loadingGroups,
      loadingRegions,
      loadingSchools,
      loadingTurmas,
      loadingSeries,
      loadingDisciplinas
    } = this.state;
    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <CCard>
          <CCardHeader>
            <h4 className="card-title mb-1">Acompanhamento Pedagógico</h4>
            <div className="small text-muted">Selecione os filtros.</div>
          </CCardHeader>
          <CCardBody>
            {loading ? (
              <Loading />
            ) : (
              <CCard className="p-4">
                <CRow>
                  <CCol sm="12" md="4" className="my-2">
                    <SelectFilter
                      title="Grupo"
                      value={groupID}
                      options={groupList}
                      loading={loadingGroups}
                      disabled={!!general.active_roles.group_id}
                      setFunction={id => {
                        this.setState(
                          {
                            groupID: id,
                            regionID: null,
                            schoolID: null,
                            serieID: null,
                            turmaID: null,
                            disciplinaID: null,
                            seriesList: []
                          },
                          async () => {
                            this.getRegions(id);
                            if (id) {
                              await Promise.all([
                                this.getSeriesWithFilters(),
                                this.loadDisciplines(id, null, null)
                              ]);
                            }
                          }
                        );
                      }}
                    />
                  </CCol>
                  <CCol sm="12" md="4" className="my-2">
                    <SelectFilter
                      title="Regiões"
                      value={regionID}
                      options={regionList}
                      loading={loadingRegions}
                      disabled={!groupID || !!general.active_roles.region_id}
                      setFunction={id => {
                        this.setState(
                          {
                            regionID: id,
                            schoolID: null,
                            turmaID: null,
                            disciplinaID: null,
                            serieID: null,
                            schoolList: [],
                            turmasList: [],
                            seriesList: []
                          },
                          async () => {
                            this.getSchools(id, groupID);
                            if (this.state.groupID && id) {
                              await Promise.all([
                                this.getSeriesWithFilters(),
                                this.loadDisciplines(
                                  this.state.groupID,
                                  id,
                                  null
                                )
                              ]);
                            }
                          }
                        );
                      }}
                    />
                  </CCol>
                  <CCol sm="12" md="4" className="my-2">
                    <SelectFilter
                      key={`school-${regionID}`}
                      title="Escolas"
                      value={schoolID}
                      options={schoolList}
                      loading={loadingSchools}
                      disabled={!regionID || !!general.active_roles.school_id}
                      setFunction={id => {
                        this.setState(
                          {
                            schoolID: id,
                            serieID: null,
                            turmaID: null,
                            disciplinaID: null,
                            turmasList: []
                          },
                          async () => {
                            this.getTurmas(id, currentYear);
                            if (
                              this.state.groupID &&
                              this.state.regionID &&
                              id
                            ) {
                              await Promise.all([
                                this.getSeriesWithFilters(),
                                this.loadDisciplines(
                                  this.state.groupID,
                                  this.state.regionID,
                                  id
                                )
                              ]);
                            }
                          }
                        );
                      }}
                    />
                  </CCol>
                  <CCol sm="12" md="4" className="my-2">
                    <SelectFilter
                      title="Ano"
                      value={currentYear}
                      options={yearList}
                      disabled={!schoolID}
                      setFunction={year => {
                        this.setState({ currentYear: year });
                        if (this.state.schoolID) {
                          this.getTurmas(
                            this.state.schoolID,
                            year,
                            this.state.serieID
                          );
                        }
                      }}
                    />
                  </CCol>
                  <CCol sm="12" md="4" className="my-2">
                    <SelectFilter
                      title="Mês"
                      value={currentMonth}
                      options={monthList}
                      disabled={!schoolID}
                      setFunction={month =>
                        this.setState({ currentMonth: month })
                      }
                    />
                  </CCol>
                  <CCol sm="12" md="4" className="my-2">
                    <SelectFilter
                      title="Série"
                      value={serieID}
                      options={seriesList}
                      loading={loadingSeries}
                      disabled={!schoolID}
                      setFunction={id => {
                        this.setState(
                          {
                            serieID: id,
                            turmaID: null,
                            disciplinaID: null,
                            turmasList: []
                          },
                          () => {
                            if (id && this.state.schoolID) {
                              this.getTurmas(
                                this.state.schoolID,
                                this.state.currentYear,
                                id
                              );
                            }
                          }
                        );
                      }}
                    />
                  </CCol>
                  <CCol sm="12" md="4" className="my-2">
                    <SelectFilter
                      key={`turma-${schoolID}-${serieID}`}
                      title="Turmas"
                      value={turmaID}
                      options={turmasList}
                      loading={loadingTurmas}
                      disabled={!serieID}
                      setFunction={id => this.setState({ turmaID: id })}
                    />
                  </CCol>
                  <CCol sm="12" md="4" className="my-2">
                    <SelectFilter
                      title="Disciplina"
                      value={disciplinaID}
                      options={disciplinasList}
                      loading={loadingDisciplinas}
                      disabled={!turmaID}
                      setFunction={id => this.setState({ disciplinaID: id })}
                    />
                  </CCol>
                </CRow>
                <CRow className="mt-3">
                  <CCol sm="12" md="2">
                    <CButton
                      color="primary"
                      className="w-100"
                      onClick={this.handleFilterClick}
                      disabled={loadingAllocations}
                    >
                      {loadingAllocations ? (
                        <>
                          <i className="fa fa-spinner fa-spin" /> &nbsp;
                          Carregando...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-filter" /> &nbsp; Filtrar
                        </>
                      )}
                    </CButton>
                  </CCol>
                </CRow>
              </CCard>
            )}
            <hr className="my-4" />
            {showTable && (
              <>
                <h5 className="mb-3">
                  Acompanhamento Pedagógico -
                  {` ${allocationsData[0]?.follow_up_name || "Não encontrado"}`}
                </h5>
                {loadingAllocations || loadingStudents ? (
                  <Loading />
                ) : (
                  <>
                    {allocationsData.length === 0 && (
                      <p className="text-muted text-center">
                        Nenhum estudante encontrado para esta turma.
                      </p>
                    )}

                    {studentList.length > 0 && (
                      <div className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="mb-0">
                            Estudantes da Turma ({studentList.length})
                          </h6>
                          {[1, 2, 3, 4].includes(
                            general.active_roles.role_id
                          ) && (
                            <CButton
                              color="info"
                              className="text-white"
                              onClick={this.handleConsolidadoClick}
                            >
                              <i className="fa fa-bar-chart" /> &nbsp;
                              Consolidado
                            </CButton>
                          )}
                        </div>
                        <div className="table-responsive">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th>Nome</th>
                                <th>Status</th>
                                <th className="d-none d-md-table-cell">
                                  Ações
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {studentList.map((student, index) => {
                                const handleRowClick = () => {
                                  const allocationId =
                                    allocationsData.length > 0
                                      ? allocationsData[0].id
                                      : 1;
                                  const studentId = student.user_id;
                                  const url = `/pedagogical-follow-ups/execution/${allocationId}/${studentId}`;
                                  window.open(url, "_blank");
                                };

                                const status = this.getStudentStatus(student);

                                return (
                                  <tr
                                    key={student.id || index}
                                    onClick={handleRowClick}
                                    className="d-md-none"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <td>{student.user_name}</td>
                                    <td>
                                      <span
                                        className={`badge ${status.class}`}
                                        style={{ fontSize: "13px" }}
                                      >
                                        {status.text}
                                      </span>
                                    </td>
                                    <td className="d-none d-md-table-cell">
                                      <CButton
                                        color="primary"
                                        onClick={e => {
                                          e.stopPropagation();
                                          handleRowClick();
                                        }}
                                      >
                                        <i className="fa fa-eye" />
                                      </CButton>
                                    </td>
                                  </tr>
                                );
                              })}
                              {studentList.map((student, index) => {
                                const handleRowClick = () => {
                                  const allocationId =
                                    allocationsData.length > 0
                                      ? allocationsData[0].id
                                      : 1;
                                  const studentId = student.user_id;
                                  const url = `/pedagogical-follow-ups/execution/${allocationId}/${studentId}`;
                                  window.open(url, "_blank");
                                };

                                const status = this.getStudentStatus(student);

                                return (
                                  <tr
                                    key={`desktop-${student.id || index}`}
                                    className="d-none d-md-table-row"
                                  >
                                    <td>{student.user_name}</td>
                                    <td>
                                      <span
                                        className={`badge ${status.class}`}
                                        style={{ fontSize: "13px" }}
                                      >
                                        {status.text}
                                      </span>
                                    </td>
                                    <td className="d-none d-md-table-cell">
                                      <CButton
                                        color={
                                          status.text === "Enviado"
                                            ? "success"
                                            : "primary"
                                        }
                                        onClick={handleRowClick}
                                      >
                                        {status.text === "Enviado" ? (
                                          <i className="fa fa-pencil" />
                                        ) : (
                                          <i className="fa fa-eye" />
                                        )}
                                      </CButton>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {studentList.length === 0 && allocationsData.length > 0 && (
                      <p className="text-muted text-center">
                        Nenhum estudante encontrado para esta turma.
                      </p>
                    )}
                  </>
                )}
              </>
            )}
          </CCardBody>
        </CCard>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  currentRoute: state.general.currentRoute
});

const mapDispatchToProps = dispatch => bindActionCreators({ setObj }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PedagogicalFollowUps);
